var __jsx = React.createElement;
import React from 'react';
import styled from 'styled-components';
import styles from './PencilBanner.style';
import RichText from '../../atoms/RichText/RichText';
var PencilBanner = function PencilBanner(_ref) {
  var bannerData = _ref.bannerData,
    className = _ref.className;
  var message = bannerData.message;
  var bannerMessage = message ? message.json : '';
  var anchorLink = bannerData && (bannerData === null || bannerData === void 0 ? void 0 : bannerData.anchorLink) || '';
  //Make sure text is not over max length
  if (bannerMessage != '') bannerMessage.content[0].content[0].value = bannerMessage.content[0].content[0].value.substring(0, 256);
  return __jsx("div", {
    className: "nva-pencil-banner ".concat(className),
    id: anchorLink
  }, __jsx(RichText, {
    ContainerElem: "div",
    jsonContent: bannerMessage,
    className: "nva-pencil-banner__message container"
  }));
};
PencilBanner.defaultProps = {
  className: ''
};
export default styled(PencilBanner).withConfig({
  componentId: "sc-143ytcg-0"
})(["", ";"], styles);